import * as ActionTypes from '../ActionTypes';

export const BuyRequests = (state = {
    isLoading: true,
    errMess: null,
    requests: []
}, action) => {
    switch(action.type) {
      case ActionTypes.SET_REQUESTS:
        return { ...state, isLoading: false, requests: action.payload };
      default:
        return state;
    }
};